<template>
  <div
    v-if="type === 'bar'"
    :class="[
      'w-[150px] h-2 flex items-start bg-quaternary  overflow-hidden ltr:ml-2 rtl:mr-2',
      { 'rounded-md': rounded },
    ]"
  >
    <div
      :class="['h-full bg-brand-solid', { 'rounded-md': rounded }]"
      :style="{ width: `${progress}%` }"
    />
  </div>
  <svg v-else-if="type === 'circle'" viewBox="0 0 100 100" class="w-8 h-8">
    <circle cx="50" cy="50" r="45" fill="transparent"></circle>
    <path
      fill="none"
      stroke-width="10"
      stroke="#F2F4F7"
      stroke-dasharray="1000"
      d="M50 10
        a 40 40 0 0 1 0 80
        a 40 40 0 0 1 0 -80"
    />
    <path
      fill="none"
      :stroke-linecap="rounded ? 'round' : 'butt'"
      stroke-width="10"
      :stroke="progress >= 100 ? 'fg-success-secondary' : 'currentColor'"
      :stroke-dasharray="calculateDashArray"
      d="M50 10
        a 40 40 0 0 1 0 80
        a 40 40 0 0 1 0 -80"
    />
  </svg>
</template>

<script setup>
/*
 * This component is a loading indicator that can be used to show the progress of an upload or any other process.
 * It can be used in two different ways: as a bar or as a circle.
 */
import { computed } from "vue";

const props = defineProps({
  progress: {
    type: Number,
    default: 0,
  },
  rounded: {
    type: Boolean,
    default: true,
  },
  type: {
    type: String,
    default: "circle",
  },
});

const calculateDashArray = computed(() => {
  const circumference = 2 * Math.PI * 40;
  return `${(props.progress / 100) * circumference} ${circumference}`;
});
</script>
